enum SignInType {
    Manual = "Manual",
    SSO = "SSO",
    Both = "Both",
}

export { SignInType }